import {
    OFFER_CHECKOUT_SUBMIT,
    OFFER_CHECKOUT_SUBMIT_ERROR,
    OFFER_CHECKOUT_SET_CUSTOMER_INFO,
    OFFER_CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
    OFFER_CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
    OFFER_CHECKOUT_SET_SELECTED_DEPOT,
    OFFER_CHECKOUT_SET_ORDER_NOTE
} from '../constants';
import { error as errorReducer } from '../../Reducers/Error.reducer';

const defaultState = {
    payload: {
        alternativeAddress: {},
        customerDetails: {},
        selectedCompanyAddressId: null,
        selectedDepotId: null,
        acceptTermsOfCondition: false,
        authenticated: false,
        companyAddresses: [],
        orderNote: null
    },
    errors: {},
    result: {},
    isSubmitting: false,
};
export const offerCheckout = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case OFFER_CHECKOUT_SUBMIT_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        case OFFER_CHECKOUT_SUBMIT:
            return {
                ...state,
                ...payload,
            };
        case OFFER_CHECKOUT_SET_CUSTOMER_INFO:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    [payload.key]: {
                        ...state.payload[payload.key],
                        ...payload.data,
                    },
                },
            };
        case OFFER_CHECKOUT_SET_SELECTED_COMPANY_ADDRESS:
        case OFFER_CHECKOUT_SET_SELECTED_DEPOT:
        case OFFER_CHECKOUT_ACCEPT_TERMS_OF_CONDITION:
        case OFFER_CHECKOUT_SET_ORDER_NOTE:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    ...payload,
                },
            };
        default:
            return state;
    }
};
